import { rem } from 'polished'
import { useMemo } from 'react'
import styled from 'styled-components'
import { ChatMap } from 'tripPlanner/components/ChatMap'
import type { ChatMapMarker } from 'tripPlanner/components/ChatMap/types'
import type { OfferDetailGeoLocation } from './types'

const MapWrapper = styled.div`
  width: 100%;
  height: ${rem(380)};
  border-radius: ${props => props.theme.borderRadius.L};
  overflow: hidden;
`

interface Props {
  geoLocation: OfferDetailGeoLocation
  offerName: string
}

function OfferDetailMap({ geoLocation, offerName }: Props) {
  const placeId = `offer-${geoLocation.lat}-${geoLocation.lng}`

  const markers = useMemo<Array<ChatMapMarker>>(() => [{
    placeId,
    lat: geoLocation.lat,
    lng: geoLocation.lng,
    label: offerName,
  }], [placeId, geoLocation.lat, geoLocation.lng, offerName])

  return (
    <MapWrapper>
      <ChatMap
        markers={markers}
        initialCenterPlaceId={placeId}
        scrollZoom={false}
      />
    </MapWrapper>
  )
}

export default OfferDetailMap
